package com.havn.app.core.platform

data class HavnEmailAttachment(
    val fileName: String,
    val contentType: String,
    val bytes: ByteArray
)

expect object HavnExternalActions {
    fun openUrl(url: String): Boolean
    fun openPhone(to: String): Boolean
    fun openEmail(to: String, subject: String, body: String): Boolean
    fun openEmailWithAttachments(to: String, subject: String, body: String, attachments: List<HavnEmailAttachment>): Boolean
    fun openEmailWithAttachments(to: List<String>, subject: String, body: String, attachments: List<HavnEmailAttachment>): Boolean
    fun openEmailWithPhotos(to: String, subject: String, body: String, photoDataUrls: List<String>): Boolean
    fun openSms(to: String, body: String): Boolean
    fun openSmsWithPhotos(to: String, body: String, photoDataUrls: List<String>): Boolean
    fun openNavigation(latitude: Double, longitude: Double): Boolean
    fun shareQrImage(
        title: String,
        message: String,
        fileName: String,
        payload: String,
        email: String?,
        phone: String?
    ): Boolean
}
